import React, { lazy} from "react";
import { BiSolidContact } from "react-icons/bi";
import { MdOutlineMiscellaneousServices } from "react-icons/md";
import { MdOutlineTouchApp } from "react-icons/md";
import { MdOutlinePermContactCalendar } from "react-icons/md";
import { MdEmail } from "react-icons/md";
import { VscLayoutMenubar } from "react-icons/vsc";
import { TbArrowBigDownLineFilled } from "react-icons/tb";
import { GrResources } from "react-icons/gr";
import { MdSupport } from "react-icons/md";

// Lazy load all admin components
const Home = lazy(() => import("views/admin/Home"));
const Services = lazy(() => import("views/admin/Services"));
const Contact = lazy(() => import("views/admin/Contact"));
const Messages = lazy(() => import("views/admin/Contact/Messages"));
const Footer = lazy(() => import("views/admin/Footer"));
const Navbar = lazy(() => import("views/admin/Navbar"));
const Company = lazy(() => import("views/admin/Company"));
const WhoWeAre = lazy(() => import("views/admin/Company/WhoWeAre"));
const OurGovernance = lazy(() => import("views/admin/Company/ourGovernance"));
const HowWeWork = lazy(() => import("views/admin/Company/howWeWork"));
const Resources = lazy(() => import("views/admin/Resources"));
const Insights = lazy(() => import("views/admin/Resources/insight"));
const Blog = lazy(() => import("views/admin/Resources/blog"));
const Testimonials = lazy(() => import("views/admin/Resources/testimonial"));
const Careers = lazy(() => import("views/admin/Resources/career"));
const CareersJobDetails = lazy(() => import("views/admin/Resources/careerJobDetails"));
const CareersJobApply = lazy(() => import("views/admin/Resources/careerJobApply"));
const DownloadedReports = lazy(() => import("views/admin/Resources/downloadedReports"));
const CTABanner = lazy(() => import("views/admin/CTA Banner"));
const Emails = lazy(() => import("views/admin/emails"));
const PrivacyPolicy = lazy(() => import("views/admin/Support/PrivacyPolicy"));
const TermsOfService = lazy(() => import("views/admin/Support/TermsOfService"));
const CookiePolicy = lazy(() => import("views/admin/Support/CookiePolicy"));
const Compliance = lazy(() => import("views/admin/Support/Compliance"));
const SignIn = lazy(() => import("views/auth/SignIn"));

// Loading component for Suspense fallback

const routes = [
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    component: (
        <SignIn />
    ),
  },
  {
    name: "Navbar",
    layout: "/admin",
    path: "navbar",
    component: (
        <Navbar />
    ),
    icon: <VscLayoutMenubar />
  },
  {
    name: "Landing Page",
    layout: "/admin",
    path: "home",
    component: (
        <Home />
    ),
  },
  {
    name: "Services",
    layout: "/admin",
    path: "services",
    component: (
        <Services />
    ),
    icon: <MdOutlineMiscellaneousServices />,
    submenu: [
      {
        name: "Services Home",
        path: "services",
        component: (
            <Services />
        )
      },
      {
        name: "Data Analytics",
        path: "data-analytics",
        component: (
            <Services />
        )
      },
      {
        name: "Data Transformation", 
        path: "data-transformation",
        component: (
            <Services />
        )
      },
      {
        name: "Data Security",
        path: "data-security", 
        component: (
            <Services />
        )
      },
      {
        name: "Data Training",
        path: "data-training",
        component: (
            <Services />
        )
      }
    ]
  },
  {
    name: "Company",
    layout: "/admin",
    path: "company",
    component: (
        <Company />
    ),
    icon: <MdOutlinePermContactCalendar />,
    submenu: [
      {
        name: "Who We Are",
        path: "who-we-are",
        component: (
            <WhoWeAre />
        )
      },
      {
        name: "Our Governance", 
        path: "our-governance",
        component: (
            <OurGovernance />
        )
      },
      {
        name: "How We Work",
        path: "how-we-work", 
        component: (
            <HowWeWork />
        )
      }
    ]
  },
  {
    name: "Resources",
    layout: "/admin",
    path: "resources",
    component: (
        <Resources />
    ),
    icon: <GrResources />,
    submenu: [
      {
        name: "Insights",
        path: "insights",
        component: (
                <Insights />
        )
      },
      {
        name: "Blog", 
        path: "blog",
        component: (
                <Blog />
        )
      },
      {
        name: "Testimonials",
        path: "testimonials", 
        component: (
            <Testimonials />
        )
      },
      {
        name: "Careers",
        path: "careers", 
        component: (
            <Careers />
        )
      },
      {
        name: "Job Details",
        path: "careers-job-details/:jobId", 
        component: (
            <CareersJobDetails />
        )
      },
      {
        name: "Applied Jobs",
        path: "careers-job-apply", 
        component: (
            <CareersJobApply />
        )
      },
    ]
  },
  {
    name: "Support",
    layout: "/admin",
    path: "support",
    
    icon: <MdSupport />,
    submenu: [
      {
        name: "Privacy Policy",
        path: "privacy-policy",
        component: (
            <PrivacyPolicy />
        )
      },
      {
        name: "Terms of Service",
        path: "terms-of-service",
        component: (
            <TermsOfService />
        )
      },
      {
        name: "Cookie Policy",
        path: "cookie-policy",
        component: (
            <CookiePolicy />
        )
      },
      {
        name: "Compliance",
        path: "compliance",
        component: (
            <Compliance />
        )
      }
    ]
  },
  {
    name: "Contact",
    layout: "/admin",
    path: "contact",
    component: (
        <Contact />
    ),
    icon: <BiSolidContact />,
    submenu: [
      {
        name: "Contact Page",
        path: "contact",
        component: (
            <Contact />
        )
      },
      {
        name: " Inquiry Messages",
        path: "messages",
        component: (
            <Messages />
        )
      },
      {
        name: "Emails",
        path: "emails",
        component: (
            <Emails />
        )
      }
    ]
  },
 
  {
    name: "CTA Banner",
    layout: "/admin",
    path: "cta-banner",
    component: (
        <CTABanner />
    ),
    icon: <MdOutlineTouchApp />
  },
  {
    name: "Footer",
    layout: "/admin",
    path: "footer",
    component: (
        <Footer />
    ),
    icon: <TbArrowBigDownLineFilled />
  },

  {
    name: "Downloaded Reports",
    layout: "/admin",
    path: "downloaded-reports",
    component: (
        <DownloadedReports />
    ),
    icon: <MdEmail />
  }
];

export default routes;
